export const ATTENDANCE_STATUSES = ['present', 'absent', 'late', 'excused'] as const;
export const ATTENDANCE_UI_ENTRY_STATUS_CYCLE = ['present', 'absent', 'late', 'excused'] as const;
export const ATTENDANCE_LEGACY_TARDY_TOKEN = 'tardy' as const;
export const ATTENDANCE_LEGACY_EARLY_DISMISSAL_TOKEN = 'earlydismissal' as const;

export type AttendanceStatus = (typeof ATTENDANCE_STATUSES)[number];

export const ATTENDANCE_STATUS_LABELS: Record<AttendanceStatus, { label: string; shortLabel: 'P' | 'A' | 'L' | 'E' }> = {
  present: { label: 'Present', shortLabel: 'P' },
  absent: { label: 'Absent', shortLabel: 'A' },
  late: { label: 'Late', shortLabel: 'L' },
  excused: { label: 'Excused', shortLabel: 'E' },
};

export const isAttendanceStatus = (value: unknown): value is AttendanceStatus =>
  typeof value === 'string' && (ATTENDANCE_STATUSES as readonly string[]).includes(value);

export const normalizeLegacyAttendanceStatus = (value: unknown): AttendanceStatus | null => {
  const normalized = String(value ?? '').trim().toLowerCase().replace(/[\s_-]+/g, '');
  if (normalized === 'present') return 'present';
  if (normalized === 'absent') return 'absent';
  if (normalized === 'late') return 'late';
  if (normalized === ATTENDANCE_LEGACY_TARDY_TOKEN) return 'late';
  if (normalized === ATTENDANCE_LEGACY_EARLY_DISMISSAL_TOKEN) return 'excused';
  if (normalized === 'excused') return 'excused';
  return null;
};

export const isAbsenceMetricStatus = (status: AttendanceStatus): boolean =>
  status === 'absent' || status === 'excused';
